export const CertificatesData = [{
        title: 'Sıfırdan Uzmanlığa React Eğitimi',
        file: '/assets/pdf/udemy-sifirdan-uzmanliga-react-egitimi-sertifika.pdf',
        image: '/assets/images/certificate/UdemySifirdanUzmanligaReactEgitimiSertifika.webp',
        date: 'Şubat 2025'
    },
    {
        title: 'ASP.NET Core 8.0 ile Web Geliştirme',
        file: '/assets/pdf/udemy-asp-net-core-8-0-ile-sifirdan-ileri-seviye-web-gelistirme-sertifika.pdf',
        image: '/assets/images/certificate/UdemyAspNetCore8_0IleSifirdanIleriSeviyeWebGelistirmeSertifika.webp',
        date: 'Aralık 2024'
    },
    {
        title: 'İngilizce A1.2',
        file: '/assets/pdf/ismek-ingilizce-a1-2-sertifika.pdf',
        image: '/assets/images/certificate/IsmekIngilizceA1_2Sertifika.webp',
        date: 'Ocak 2024'
    },
    {
        title: 'E-Ticaret Yönetimi',
        file: '/assets/pdf/ismek-eticaret-yonetimi-sertifika.pdf',
        image: '/assets/images/certificate/IsmekEticaretYonetimiSertifika.webp',
        date: 'Ocak 2024'
    },
    {
        title: 'Modern Web Geliştirme İleri Seviye',
        file: '/assets/pdf/udemy-modern-web-gelistirme-kursu-sifirdan-ileri-seviyeye-sertifika.pdf',
        image: '/assets/images/certificate/UdemyModernWebGelistirmeKursuSifirdanIleriSeviyeyeSertifika.webp',
        date: 'Aralık 2023'
    },
    {
        title: 'Html Css Js ile E-Ticaret Sitesi Yapımı',
        file: '/assets/pdf/udemy-html-css-ve-javascript-ile-eticaret-sitesi-yapimi-sertifika.pdf',
        image: '/assets/images/certificate/UdemyHtmlCssVeJavascriptIleEticaretSitesiYapimiSertifika.webp',
        date: 'Aralık 2023'
    },
    {
        title: 'İngilizce A1.1',
        file: '/assets/pdf/ismek-ingilizce-a1-1-sertifika.pdf',
        image: '/assets/images/certificate/IsmekIngilizceA1_1Sertifika.webp',
        date: 'Ekim 2023'
    },
    {
        title: 'C# Programlama Dili',
        file: '/assets/pdf/udemy-csharp-programlama-dili-sertifika.pdf',
        image: '/assets/images/certificate/UdemyCsharpProgramlamaDiliSertifika.webp',
        date: 'Mart 2023'
    }
]